var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "32", height: "32", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "linkedin"
    ),
    React.createElement("path", { d: "M27.268 27.268h-4.745V19.84c0-1.77-.03-4.049-2.466-4.049-2.47 0-2.847 1.93-2.847 3.923v7.553h-4.74V11.996h4.549v2.088h.065c.633-1.2 2.182-2.466 4.49-2.466 4.806 0 5.694 3.162 5.694 7.274v8.376zM7.118 9.91a2.751 2.751 0 0 1-2.754-2.753 2.751 2.751 0 1 1 5.504 0 2.752 2.752 0 0 1-2.75 2.753zM4.741 27.268h4.751V11.996h-4.75v15.272zM29.632 0H2.36C1.058 0 0 1.033 0 2.308V29.69C0 30.965 1.058 32 2.36 32h27.272c1.305 0 2.367-1.035 2.367-2.31V2.309C32 1.033 30.937 0 29.632 0z", fill: "#000", fillRule: "evenodd" })
  );
});